import { injectable } from 'inversify';

import { IUsersRepository } from '@/domain/repositories/create-user.repository.interface';
import { Result } from '@/entities/Result';
import { Options } from '@/entities/UserData';
import { checkEmail, checkLastNameAndPhone, createUser } from '@/infrastructure/network/data/users';
import { UserCreateFormData } from '@/infrastructure/network/dto/UserCreateDto';
import { UserDataDto } from '@/infrastructure/network/dto/UserDataDto';

@injectable()
export class UsersRepository implements IUsersRepository {
	async createUser(data: UserCreateFormData): Promise<Result<UserDataDto>> {
		const result = await createUser(data);
		if (result.statusCode === 201) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async checkEmail(email: string): Promise<Result<UserDataDto>> {
		const result = await checkEmail({ email });
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async checkLastNameAndPhone(lastName: string, phoneCountryId: string, phone: string): Promise<Result<Options[]>> {
		const result = await checkLastNameAndPhone({ lastName, phoneCountryId, phone });
		if (result.statusCode === 204) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
